<template>
  <div class="change-avatar__modal">
    <div class="change-avatar__options-container" :class="{'change-avatar__options-container_uploaded': preloader}">
      <h2>
        Изменить аватар
      </h2>
      <div class="change-avatar__options">
        <div class="change-avatar__current-avatar">
          <h3>
            Текущий аватар:
          </h3>
          <img class="" alt="текущий аватар" :src="newAvatar">
          <input type="file" id="loadAvatar" @change="uploadingAvatar($event)" accept="image/*">
          <label for="loadAvatar">
            <img alt="Плюс" src="../../assets/images/plus.png">
            Загрузить фото
          </label>
          <div v-if="fileProperties.name" class="change-avatar__hint change-avatar__hint_name-avatar">
            {{ fileProperties.name }}
          </div>
          <div v-if="!warning" class="change-avatar__hint" :class="{'change-avatar__hint_notWarning': warning}">
            * Вы можете загрузить изображение до 200 кб
          </div>
          <div v-else v-for="warning in descWarning" :key="warning.typeWarn"
               class="change-avatar__hint change-avatar__hint_warning">
            <img src="/local/templates/adaptive_cmtshop/reviews/src/assets/images/alert-circle-outline.png" alt="">
            {{ warning.desc }}
          </div>
        </div>
        <div class="change-avatar__options-detail">
          <h3>
            Выбрать из предложенных
          </h3>
          <form>
            <div class="change-avatar__options-gender">
              <h4>
                Ваш пол:
              </h4>
              <div v-for="gender in optionsData.genders">
                <input type="radio" :id="gender.CODE" :value="gender.CODE" v-model="currentAvatar.gender">
                <label :for="gender.CODE">
                  {{ gender.NAME }}
                </label>
              </div>
            </div>
            <div class="change-avatar__options-hair-color">
              <h4>
                Цвет волос:
              </h4>
              <div class="change-avatar__select">
                <div class="change-avatar__select-checked">
                  {{ paramsAvatar.hairColor }}
                  <img src="/local/templates/adaptive_cmtshop/reviews/src/assets/images/arrow.png" alt="стрелка">
                </div>
                <ul class="change-avatar__select-list" @click="changeColor($event)">
                  <li v-for="hair in optionsData.hairStyles" :data-color="hair.CODE">
                    {{ hair.NAME }}
                  </li>
                </ul>
              </div>
            </div>
          </form>
          <div>
            <div class="change-avatar__options-avatar">
              <img :data-file="item.file_id" :alt="item.title" :src="item.src"
                   v-for="(item, index) in optionsData.avatars" :key="item.id" v-show="filtrAvatar(item)"
                   @click="changeStandardAvatar($event)">
            </div>
          </div>
        </div>
      </div>
      <div class="change-avatar__button">
        <button class="change-avatar__button-save" type="button" @click="loadedServer()">
          Сохранить
        </button>
        <button class="change-avatar__button-cancel" type="button" @click="closeModal()">
          Отменить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ChangeAvatarOptions",
  data() {
    return {
      newAvatar              : this.currentAvatar.src,
      fileForUpload          : '',
      defaultAvatar          : false,
      selectedDefaultAvatarId: '',
      fileProperties         : {
        name: '',
        size: '',
        type: ''
      },
      typeAvatar             : ['png', 'jpg', 'gif', 'jpe', 'jpeg'],
      warning                : false,
      descWarning            : [],
      paramsAvatar           : {
        gender   : '',
        hairColor: '',
        hairCode : ''
      },
      preloader: false,
    }
  },
  props: {
    optionsData  : {
      type: Object
    },
    currentAvatar: {
      type: Object
    }
  },
  created() {
    this.filtrAvatar();
  },
  methods: {
    //Выбор цвета в селлекте
    changeColor(e) {
      if (e.target.tagName === 'LI') {
        this.paramsAvatar.hairColor = e.target.innerHTML.trim();
        this.paramsAvatar.hairCode = e.target.dataset.color;
      }
    },
    //Фильтр по сортировке стандартных аватарок
    filtrAvatar(item) {
      if (item) {
        if (this.currentAvatar.gender && this.paramsAvatar.hairCode) {
          if (item.gender === this.currentAvatar.gender
              && item.hairStyle === this.paramsAvatar.hairCode) {
            return true;
          }
        }
        if (this.currentAvatar.gender && !this.paramsAvatar.hairCode) {
          if (item.gender === this.currentAvatar.gender) {
            return true;
          }
        }
        if (!this.currentAvatar.gender && this.paramsAvatar.hairCode) {
          if (item.hairStyle === this.paramsAvatar.hairCode) {
            return true;
          }
        }
      }

      return false;
    },
    //Закрытие модального окна
    closeModal() {
      this.$emit('closeModal');
    },
    //Метод выбора стандартного изображения
    changeStandardAvatar(event) {
      this.newAvatar = event.target.currentSrc;
      for (const key in this.fileProperties) {
        this.fileProperties[key] = '';
      }
      this.warning = false;
      this.defaultAvatar = true;
      this.fileForUpload = '';
      this.selectedDefaultAvatarId = event.target.dataset.file;
    },
    //Метод загрузки своей аватарки
    uploadingAvatar(avatar) {
      this.descWarning = [];
      this.fileProperties.name = avatar.target.files[0].name;
      this.fileProperties.size = avatar.target.files[0].size;
      this.fileProperties.type = avatar.target.files[0].type;

      //Переводим тип загружаемой картинки в ссылку для динамического отображения
      let reader = new FileReader();
      let img = avatar.target.files[0]
      reader.readAsDataURL(img);

      reader.onload = () => {
        this.newAvatar = reader.result;
      };

      this.checkSizeImg(this.fileProperties.size);
      this.checkTypeImg(this.fileProperties.type);

      this.descWarning.length < 1 ? this.warning = false : '';
      this.fileForUpload = avatar.target.files[0];
      this.defaultAvatar = false;

    },
    //Методы проверки корректности загружаемого изображения
    checkSizeImg(sizeAvatar) {
      if (sizeAvatar > 204800) {
        this.warning = true;
        this.descWarning.push(
            {
              typeWarn: 'size',
              desc    : 'Размер изображения превышает 200 кб'
            });
      }
    },
    checkTypeImg(typeAvatar) {
      const typeImg = this.typeAvatar.includes(typeAvatar.split("/")[1]);
      if (!typeImg) {
        this.warning = true;
        this.descWarning.push({
          typeWarn: 'type',
          desc    : 'Изображение должно быть в формате (img, png)'
        });
      }
    },
    //Метод отправки выбранной аватарки на сервер
    async loadedServer() {
      if (this.descWarning.length < 1) {
        let formData = new FormData();

        formData.append('sessid', this.$parent.getSessid());

        if (this.defaultAvatar) {
          formData.append('file_id', this.selectedDefaultAvatarId);
        } else if (this.fileForUpload) {
          formData.append('file', this.fileForUpload)
        } else {
          this.closeModal();
          return;
        }

        if (formData)
          this.preloader = true;
          axios
              .post('/api/forum/v1/avatar/', formData, {
                headers        : {
                  'Content-Type': 'multipart/form-data',
                },
                withCredentials: true
              })
              .then(response => {
                const result = response.data;
                this.preloader = false;

                if (result.result) {
                  this.$parent.setUserAvatar(result.userAvatar);
                  this.closeModal();
                } else {
                  this.descWarning.push({
                    typeWarn: 'type',
                    desc    : result.error
                  });
                }
              });
      }
    }
  },
  mounted() {

  },
}
</script>

<style></style>